import React from 'react';
import { Link } from "../../Styles/LinkText/LinkTextStyle"

const LinkText = ({text, url}) => <Link href={url} target="_blank">{text}</Link>

export default LinkText;